export const reshapeAccount = (account) => ({
    ...account,
    firstVisitTime: new Date(account.createDate),
    lastVisitTime: new Date(account.lastAccess),
    twoFactorAuthenticationEnabled: account.isTwoFactorEnabled,
});
